import styled from 'styled-components';

export const DataBox = styled.div`
  padding: 4rem 0;
  display: flex;
  align-items: center;
`;

export const LoadingBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
